(() => {
  if (customElements.get('flipside-hero')) return;
  customElements.define('flipside-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const slides = [...this.querySelectorAll('[data-hero-slide]')];
      const dots = [...this.querySelectorAll('[data-hero-go]')];
      const controls = this.querySelector('.fs-home__hero-controls');
      const toggle = this.querySelector('[data-hero-toggle]');
      if (slides.length < 2 || !controls || !toggle) return;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let timer;
      let paused = false;
      let focused = false;
      let visible = true;
      const show = (next) => {
        index = next;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      };
      const schedule = () => {
        clearTimeout(timer);
        toggle.hidden = motion.matches;
        toggle.textContent = paused ? 'Play' : 'Pause';
        toggle.setAttribute('aria-label', paused ? 'Play photo slideshow' : 'Pause photo slideshow');
        if (paused || focused || !visible || motion.matches || document.hidden) return;
        timer = setTimeout(() => {
          show((index + 1) % slides.length);
          schedule();
        }, 6000);
      };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-hero-go')) {
          const next = Number(button.dataset.heroGo);
          if (!Number.isInteger(next) || next < 0 || next >= slides.length) return;
          focused = button.matches(':focus-visible');
          show(next);
        } else if (button === toggle) {
          paused = !paused;
          if (!paused) focused = false;
        } else return;
        schedule();
      }, options);
      this.addEventListener('focusin', (event) => {
        focused = event.target.matches(':focus-visible');
        schedule();
      }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (abort.signal.aborted) return;
          focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          schedule();
        });
      }, options);
      document.addEventListener('visibilitychange', schedule, options);
      motion.addEventListener('change', schedule, options);
      const observer = typeof IntersectionObserver === 'function'
        ? new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; schedule(); })
        : null;
      observer?.observe(this);
      this.cleanup = () => { abort.abort(); clearTimeout(timer); observer?.disconnect(); };
      show(0);
      controls.hidden = false;
      schedule();
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
})();
